<!-- 离场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "abnormalOutReason": "",
                "abnormalOutRemark": "",
                "actualReceivable": 0,
                "amountReceivable": 0,
                "carLicenseNumber": "未识别0928141457424",
                "chargeState": 1,
                "cmd": "reportCarOut",
                "confidence": 0,
                "correctConfidence": 0,
                "correctType": 0,
                "discountAmount": 0,
                "enterCarCardNumber": "",
                "enterCarColor": 0,
                "enterCarLicenseColor": 0,
                "enterCarLicenseNumber": "",
                "enterCarLicenseType": 0,
                "enterCarLogo": 0,
                "enterCarType": 1,
                "enterChannelId": 5628,
                "enterChannelCustomCode": "56228",
                "enterChannelName": "",
                "enterCustomVipName": "",
                "enterImageArray": [
                    {
                        "carImage": "http://221.4.168.157:13388/openydt/files/images/2017092814144704966576-body-in-nor.jpg?s=916f6395"
                    }
                ],
                "enterNovipCode": 1,
                "enterRecognitionConfidence": 0,
                "enterSpeed": 0,
                "enterStatisticalArea": "",
                "enterTime": "20170928141447",
                "enterType": 0,
                "enterVipRule": "",
                "enterVipType": 1,
                "inOperatorName": "",
                "isCorrect": 0,
                "isManualMatch": 0,
                "lastCorrectLicenseNumber": "",
                "lastCorrectName": "",
                "leaveCarCardNumber": "",
                "leaveCarColor": 0,
                "leaveCarLicenseColor": 1,
                "leaveCarLicenseNumber": "未识别0928141457424",
                "leaveCarLicenseType": 0,
                "leaveCarLogo": 0,
                "leaveCarType": 1,
                "leaveChannelId": 122,
                "leaveChannelCustomCode": "122",
                "leaveChannelName": "Fu_Out",
                "leaveChargeGroupCode": "1",
                "leaveCustomVipName": "",
                "leaveImageArray": [
                    {
                        "carImage": "http://221.4.168.157:13388/openydt/files/images/2017092814144704966576-body-out-nor.jpg?s=625ea49e"
                    }
                ],
                "leaveNovipCode": 1,
                "leaveRecognitionConfidence": 0,
                "leaveSpeed": 0,
                "leaveStatisticalArea": "1,10",
                "leaveTime": "20170928141447",
                "leaveType": 0,
                "leaveVipRule": "",
                "leaveVipType": 1,
                "outOperatorName": "",
                "parkChargeDetailList": [],
                "parkCode": "2KNTYVWC",
                "parkingCode": "2017092814144704966576",
                "platformShouldPay": 0,
                "realCharge": 0,
                "recordType": 0,
                "reliefCharge": 0,
                "remark": "",
                "stoppingTime": 0,
                "tollCollectorName": "",
                "totalAmount": 0,
                "openGateTime": 500,
                "thirdUserList":[{"userPhone":"18200946810"}]
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报车辆离场信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportCarOut",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场, 路边车场 (上报图片保留90天)",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '最终车牌号' },
                        { info1: 'confidence', info2: '是', info3: 'Decimal', info4: '最终识别置信度' },
                        { info1: 'enterCarLicenseNumber', info2: '否', info3: 'String', info4: '进场车牌号' },
                        { info1: 'enterCarCardNumber', info2: '否', info3: 'String', info4: '进场卡号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        // { info1: 'enterChannelCode', info2: '否', info3: 'String', info4: '进场通道编码，路边停车场没有，云停车场为通道ID，VEMS为通道自定义编码' },
                        { info1: 'enterChannelId', info2: '否', info3: 'Long', info4: '进场通道ID，路边停车场没有' },
                        { info1: 'enterChannelCustomCode', info2: '否', info3: 'String', info4: '进场通道编码，路边停车场没有' },
                        { info1: 'enterChannelName', info2: '是', info3: 'String', info4: '进场通道名，路边停车场没有' },
                        { info1: 'enterVipType', info2: '是', info3: 'Integer', info4: '进场Vip类型（0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客）' },
                        { info1: 'enterType', info2: '是', info3: 'Integer', info4: '进场类型（0未确认，1自动放行，2确认放行，3异常放行）' },
                        { info1: 'enterSpeed', info2: '否', info3: 'Decimal', info4: '进场速度' },
                        { info1: 'enterCarLicenseColor', info2: '否', info3: 'Integer', info4: '进场车牌颜色（0未定义，1蓝色，2黄色，3白色，4黑色，5绿色）' },
                        { info1: 'enterCarColor', info2: '否', info3: 'Integer', info4: '进场车辆颜色（0未定义，1白色,2黑色,3红色,4绿色,5粉色,6蓝色,7紫色，8灰色,9雪青，10葱绿，11黄色，12橙色）' },
                        { info1: 'enterCarLogo', info2: '否', info3: 'Integer', info4: '进场车标' },
                        { info1: 'enterCarLicenseType', info2: '否', info3: 'Integer', info4: '进场车牌类型（0未定义，1蓝牌白字，2黄牌黑字，3黑牌白字，4白牌）' },
                        { info1: 'enterCarType', info2: '否', info3: 'Integer', info4: '进场车辆类型（0未知，1蓝牌车，2黄牌车"，3超大型车 4新能源小车，5新能源大车（vems：20 非机动车））' },
                        { info1: 'enterRecognitionConfidence', info2: '是', info3: 'Decimal', info4: '进场识别置信度' },
                        { info1: 'recordType', info2: '否', info3: 'Integer', info4: '记录类型（0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发）' },
                        { info1: 'isCorrect', info2: '是', info3: 'Integer', info4: '车牌是否被纠正（0未纠正，1已纠正）' },
                        { info1: 'correctConfidence', info2: '否', info3: 'Decimal', info4: '校正置信度' },
                        { info1: 'correctType', info2: '否', info3: 'Integer', info4: '校正类型（0未校正，1手动校正，2自动校正）' },
                        { info1: 'lastCorrectLicenseNumber', info2: '否', info3: 'String', info4: '最后校正校正车牌' },
                        { info1: 'lastCorrectName', info2: '否', info3: 'String', info4: '最后校正人名' },
                        { info1: 'lastCorrectTime', info2: '否', info3: 'String', info4: '最后校正时间，yyyyMMddHHmmss' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'inOperatorName', info2: '是', info3: 'String', info4: '入场放行操作员' },
                        { info1: 'inOperateTime', info2: '是', info3: 'String', info4: '入场放行时间，yyyyMMddHHmmss' },
                        { info1: 'enterCustomVipName', info2: '是', info3: 'String', info4: '进场VIP名称' },
                        { info1: 'enterStatisticalArea', info2: '否', info3: 'String', info4: '进场统计区域' },
                        { info1: 'enterNovipCode', info2: '否', info3: 'Integer', info4: '详细请看附录进出场说明枚举' },
                        { info1: 'enterVipRule', info2: '否', info3: 'String', info4: '进场vip' },
                        { info1: 'enterImageArray', info2: '是', info3: 'JSONArray', info4: '入场图片列表，[{"carImage":"车身图片直接访问url"}]<br>'  + '注：智汇云不提供车牌图片(上报图片保留90天)' },
                        { info1: 'leaveCarLicenseNumber', info2: '是', info3: 'String', info4: '出场车牌号' },
                        { info1: 'leaveCarCardNumber', info2: '否', info3: 'String', info4: '出场卡号' },
                        { info1: 'leaveTime', info2: '是', info3: 'String', info4: '出场时间，yyyyMMddHHmmss' },
                        // { info1: 'leaveChannelCode', info2: '否', info3: 'String', info4: '出场通道编码，路边停车场没有，云停车场为通道ID，VEMS为通道自定义编码' },
                        { info1: 'leaveChannelId', info2: '否', info3: 'Long', info4: '出场通道ID，路边停车场没有' },
                        { info1: 'leaveChannelCustomCode', info2: '否', info3: 'String', info4: '出场通道编码，路边停车场没有' },
                        { info1: 'leaveChannelName', info2: '是', info3: 'String', info4: '出场通道名，路边停车场没有' },
                        { info1: 'leaveVipType', info2: '是', info3: 'Integer', info4: '出场Vip类型（<url>参考附录:/Api/appendixData</url>VIP类型）' },
                        { info1: 'leaveType', info2: '是', info3: 'Integer', info4: '出场类型，（<url>参考附录:/Api/appendixData</url>进出场类型）' },
                        { info1: 'leaveSpeed', info2: '否', info3: 'Decimal', info4: '出场速度' },
                        { info1: 'leaveCarLicenseColor', info2: '否', info3: 'Integer', info4: '出场车牌颜色（0未定义，1蓝色，2黄色，3白色，4黑色，5绿色）' },
                        { info1: 'leaveCarColor', info2: '否', info3: 'Integer', info4: '出场车辆颜色（0未定义，1白色,2黑色,3红色,4绿色,5粉色,6蓝色,7紫色，8灰色,9雪青，10葱绿，11黄色，12橙色）' },
                        { info1: 'leaveCarLicenseType', info2: '否', info3: 'Integer', info4: '出场车牌类型（1蓝牌白字，2黄牌黑字，3黑牌白字，4白牌）' },
                        { info1: 'leaveCarType', info2: '否', info3: 'Integer', info4: '出场车辆类型（0未知，1蓝牌车，2黄牌车"，3超大型车 4新能源小车，5新能源大车（vems：20 非机动车））' },
                        { info1: 'leaveRecognitionConfidence', info2: '是', info3: 'Decimal', info4: '出场识别置信度' },
                        { info1: 'leaveStatisticalArea', info2: '否', info3: 'String', info4: '出场统计区域' },
                        { info1: 'leaveNovipCode', info2: '否', info3: 'Integer', info4: '详细请看附录进出场说明枚举' },
                        { info1: 'leaveVipRule', info2: '否', info3: 'String', info4: '离场vip' },
                        // { info1: 'leaveChannelCode', info2: '否', info3: 'String', info4: '离场通道编号' },
                        { info1: 'leaveChargeGroupCode', info2: '否', info3: 'String', info4: '计费规则编号' },
                        { info1: 'outOperatorName', info2: '是', info3: 'String', info4: '放出操作员名' },
                        { info1: 'outOperatorTime', info2: '是', info3: 'String', info4: '放出操作时间，yyyyMMddHHmmss' },
                        { info1: 'tollCollectorName', info2: '否', info3: 'String', info4: '收费员' },
                        { info1: 'tollCollectTime', info2: '否', info3: 'String', info4: '收费时间，yyyyMMddHHmmss' },
                        { info1: 'leaveCustomVipName', info2: '否', info3: 'String', info4: '出场VIP名称' },
                        { info1: 'leaveImageArray', info2: '是', info3: 'String', info4: '出场图片列表，[{"carImage":"车身图片直接访问url"}]<br>'  + '注：智汇云不提供车牌图片(上报图片保留90天)' },
                        { info1: 'abnormalOutReason', info2: '否', info3: 'String', info4: '异常放行原因' },
                        { info1: 'abnormalOutRemark', info2: '否', info3: 'String', info4: '异常放行备注' },
                        { info1: 'isManualMatch', info2: '否', info3: 'Integer', info4: '是否手动匹配（0否，1是）' },
                        { info1: 'chargeState', info2: '否', info3: 'Integer', info4: '' },
                        { info1: 'totalAmount', info2: '是', info3: 'Decimal', info4: '停车费用' },
                        { info1: 'amountReceivable', info2: '是', info3: 'Decimal', info4: '应收金额' },
                        { info1: 'discountAmount', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'actualReceivable', info2: '是', info3: 'Decimal', info4: '车主实付金额' },
                        { info1: 'openGateTime', info2: '否', info3: 'Integer', info4: '一体机抓拍到开闸的时长（单位：毫秒）。vems2.13以上支持' },
                        { info1: 'parkChargeDetailList', info2: '是', info3: 'JSONArray', info4: '支付账单列表（云停车场该字段暂不支持）' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        { info1: 'thirdUserList', info2: '否', info3: 'JSONArray', info4: '该车牌的第三方用户列表（是该合作方的用户才会上报，含义：必须是通过该授权商调用“第三方会员无缝嵌入智慧停车微信”登录智慧停车微信的用户，其车辆进出场消息才会含有手机号码）' },
                        { info1: 'extendInfo', info2: '否', info3: 'JSONObject', info4: '附加信息' },
                      { info1: 'fromAreaId', info2: '否', info3: 'String', info4: '来源区域 ：0为车场外部，其余为区域编码' },
                      { info1: 'toAreaId', info2: '是', info3: 'String', info4: '目的区域：0为车场外部，其余为区域编码' },
                        ]
                },{
                    titleName: 'parkChargeDetailList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '支付订单号' },
                        { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
                        { info1: 'actPayCharge', info2: '是', info3: 'Decimal', info4: '车主实付金额' },
                        { info1: 'reliefCharge', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'platformShouldPay', info2: '是', info3: 'Decimal', info4: '平台扣款(自动扣费时使用)' },
                        { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式' },
                        { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源' },
                        { info1: 'payModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'collectorName', info2: '是', info3: 'String', info4: '收费员' },
                        { info1: 'desc', info2: '是', info3: 'String', info4: '描述' },
                        { info1: 'couponList', info2: '是', info3: 'JSONArray', info4: '账单对应优惠信息列表' }
                        ]
                },{
                    titleName: 'couponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '券类型（0免费券；1金额扣减券；2金额折扣券；3金额固定值券，车费按券的固定值结算；4时间券，时间减免后再按车费结算；5不同计价券,按不同计价规则车费结算;6、时间段封顶券）。特别注意：临停缴费上报中对应字段的含义是有区别的' },
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '券名称' },
                        { info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '券编号' },
                        { info1: 'couponOriginType', info2: '是', info3: 'Integer', info4: '券来源类型, 0本地优惠 1商家优惠 2自动券优惠' }
                        ]
                },{
                    titleName: 'thirdUserList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userPhone', info2: '是', info3: 'String', info4: '用户手机号' }
                        ]
                },{
                    titleName: 'extendInfo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'selfInCode', info2: '是', info3: 'String', info4: '自助进场随机码' },
                        { info1: 'selfInUserUniqCode', info2: '是', info3: 'String', info4: '自助进场用户标识' },
                        { info1: 'selfOutCode', info2: '是', info3: 'String', info4: '自助出场随机码' },
                        { info1: 'selfOutUserUniqCode', info2: '是', info3: 'String', info4: '自助出场用户标识' },
                        { info1: 'enterNoVipCodeName', info2: '是', info3: 'Integer', info4: '进场说明（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'leaveNoVipCodeName', info2: '是', info3: 'Integer', info4: '出场说明（<url>参考附录:/Api/appendixData</url>）' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportCarOut.vue